<template>
  <v-btn id='stripe-checkout' class="v-btn info btn-big" @click="disableButton(); redirectToStripe()">決済画面へ</v-btn>
</template>

<script>
  import { loadStripe } from '@stripe/stripe-js'
  import axios from 'axios'

  export default {
    props: [
      'stripeKey',
      'seminarPriceId',
      'userId',
      'seminarId',
      'membersCount'
    ],

    data () {
      return {
        seminarPriceId: this.seminarPriceId,
        userId: this.userId,
        seminarId: this.seminarId,
        membersCount: this.membersCount,
        stripe: loadStripe(this.stripeKey)
      }
    },

    methods: {
      disableButton () {
        document.getElementById('stripe-checkout').disabled = true
      },

      redirectToStripe: async function () {
        await axios.get('/api/create-seminar-checkout-session', {
          params: {
            userId: this.userId,
            seminarId: this.seminarId,
            seminarPriceId: this.seminarPriceId,
            membersCount: this.membersCount
          }
        }).then(async res => {
          const data = res.data

          if (res.status !== 200 || !data || data.error) {
            document.getElementById('stripe-checkout').disabled = false
            return false
          }          

          const stripe = await loadStripe(this.stripeKey)

          stripe.redirectToCheckout({
            sessionId: data.sessionId
          })

        }).catch(res => {
          document.getElementById('stripe-checkout').disabled = false
          console.log(res)
        })
      },
    }
  }
</script>